/**
 * @flow
 *
 * Feathers client
 */
import feathers from '@feathersjs/client';
import rest from '@feathersjs/client/rest';
import fetch from 'cross-fetch';
import invariant from 'invariant';

/** Custom imports */
import appHooks from './app.hooks';

function feathersClient(apiServer) {
  invariant(apiServer, 'API server is not set');

  const app = feathers();
  const restClient = rest(apiServer);

  app.configure(restClient.fetch(fetch));

  /**
   * TODO: Auth can be improved look for feathers docs.
   */
  // app.configure(feathers.authentication({
  //   storage: window.localStorage,
  // }));

  app.hooks(appHooks);

  return app;
}

export default feathersClient;



// WEBPACK FOOTER //
// ./src/application/client/app.client.js